import ClearIcon from '@mui/icons-material/Clear';
import { Stack } from '@mui/material';
import { FC } from 'react';
import { Connection } from '@/types/connection';
import ConfirmPopover from '@/components/common/ConfirmPopover';
import ListArrows from '@/components/common/ListArrows';
import TextFieldWrapper from '@/components/common/TextFieldWrapper';

type CustomListItemProps = {
  action: string;
  label: string;
  data: Connection[];
  index: number;
  onArrowClick: (data: Connection[]) => void;
  onChange: (id: string, label: string) => void;
  onDelete: () => void;
};

const CustomListItem: FC<CustomListItemProps> = (props) => {
  return (
    <Stack direction='row' gap={1} alignItems='center'>
      <TextFieldWrapper
        size='small'
        label='ID'
        value={props.action}
        fullWidth
        autoFocus={!props.action}
        onChange={(event) => props.onChange(event.currentTarget.value, props.label)}
      />
      <TextFieldWrapper
        size='small'
        label='Label'
        value={props.label}
        fullWidth
        autoFocus={!!props.action && !props.label}
        onChange={(event) => props.onChange(props.action, event.currentTarget.value)}
      />
      <ListArrows data={props.data} index={props.index} onChange={(data) => props.onArrowClick(data as Connection[])} />
      <ConfirmPopover
        onConfirm={props.onDelete}
        icon={<ClearIcon />}
        text={`Remove ${props.action}?`}
        skipConfirm={!props.action && !props.label}
      />
    </Stack>
  );
};

export default CustomListItem;
